import './app.css';
import { mount } from 'svelte';
import App from './App.svelte';
import { initTheme } from './lib/theme.svelte.js';

function boot() {
  const target = document.getElementById('strao-portal-app');
  if (!target) {
    console.error('STRAO Portal: mount point #strao-portal-app not found');
    return null;
  }
  initTheme();
  return mount(App, { target });
}

let app = null;
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => { app = boot(); });
} else {
  app = boot();
}

export default app;
